import {produce} from 'immer';
import {useState} from 'react';

export function useImmerState<T>(init: () => T): [T, ImmerSetState<T>] {
    const [state, setState] = useState(init);
    const setImmerState = function setImmerState(recipe: (state: T) => T | void) {
        setState(current => produce(current, recipe));
    };
    return [state, setImmerState];
}

export type ImmerSetState<T> = (recipe: (state: T) => T | void) => void;
